import { lazy } from 'react';
import ComponentLoader from 'src/components/ComponentLoader';
import Module from 'src/config/models/Module';
import ModuleBundle from 'src/config/models/ModuleBundle';

export const ReturnViewModule = new Module({
  id: 'RETURN:VIEW:*',
  name: 'Return',
  label: 'return',
  path: 'return',
  Component: ComponentLoader(
    lazy(() => import('src/content/management/Return/View'))
  ),
  actions: {
    addBulkRequest: {
      id: 'RETURN:ADD:BULK-ADD',
      label: 'Bulk Add',
      name: 'add-bulk-request'
    },
    viewDetails: {
      id: 'RETURN:VIEW:DETAILS',
      label: 'View Details',
      name: 'view-details'
    },
    // startPDIAgainstOrder: {
    //   id: 'ORDERS:VIEW:START-PDI-ORDER-t',
    //   name: 'start-pdi-against-order',
    //   label: 'Start PDI'
    // },
    // editFirmwareInOrder: {
    //   id: 'ORDERS:VIEW:EDIT-FIRMWARE-IN-ORDER-t',
    //   name: 'edit-firmware-in-order',
    //   label: 'Edit Firmware'
    // },
    // cancelOrder: {
    //   id: 'ORDERS:VIEW:CANCEL-ORDER-t',
    //   name: 'cancel-order',
    //   label: 'Cancel Order'
    // },
    // opeMoadal: {
    //   id: 'SERVICES:VIEW:SERVICE-MODAL',
    //   name: 'service-modal',
    //   label: 'Details'
    // },
    // opeDispatchModal: {
    //   id: 'SERVICES:VIEW:DISPATCH-MODAL',
    //   name: 'dispatch-modal',
    //   label: 'Dispatch'
    // }
  }
});

export const ReturnDetailsModule = new Module({
  id: 'RETURN:VIEW:DETAILS',
  name: 'returnDetails',
  path: 'return/details',
  pathDef: 'return/details/:orderId',
  Component: ComponentLoader(
    lazy(() => import('src/content/management/Return/Form'))
  )
});


export const AddBulkRequestModule = new Module({
  id: 'RETURN:ADD:BULK-ADD',
  name: 'add-bulk-request',
  path: 'return/add-bulk-request',
  Component: ComponentLoader(
    lazy(() => import('src/content/management/Return/BulkAdd'))
  ),
  actions: {
    // viewReport: {
    //   id: 'ORDERS:VIEW:REPORT-t',
    //   name: 'view-report',
    //   label: 'View Report'
    // },

    deleteAllocatedMaterial: {
      id: 'RETURN:DELETE:IMEI',
      name: 'delete-imei',
      label: 'Delete IMEI'
    },
  }
});

const ReturnModules = [
  ReturnViewModule,
  ReturnDetailsModule,
  AddBulkRequestModule
  // MaterialAllocationModule
];

export default new ModuleBundle('Return', ReturnModules);
